<template>
  <div v-if="instructors">
    <h1 :style="{ margin: useLoginStore().isAdmin ? '0 0 4px' : '0 0 -20px' }">
      Instructors
    </h1>
    <div class="d-flex justify-content-between align-items-start mb-2">
      <div>
        <hilo-button
          v-if="useLoginStore().isAdmin"
          label="Add +"
          @click="navigateToAddInstructor"
        />
      </div>
      <input
        class="search-input"
        v-model="search"
        placeholder="Search"
        @input="filterInstructors"
      />
    </div>
    <hilo-table :columns="columns" :data="filteredInstructors" />
  </div>
</template>
<script>
import HiloTable from "src/components/HiloComponents/HiloTable.vue";
import ActiveInstructorsAPIService from "src/servicehandlers/ActiveInstructorsAPIService.js";
import HiloButton from "../../../components/HiloComponents/HiloButton.vue";
import { useLoginStore } from "@/stores/loginStore";
const activeInstructorsAPIService = new ActiveInstructorsAPIService();

export default {
  name: "Instructors",
  components: {
    HiloButton,
    HiloTable,
  },
  data() {
    return {
      instructors: [],
      filteredInstructors: [],
      search: "",
      columns: [
        ...(useLoginStore().isAdmin
          ? [
              {
                key: "edit",
                label: "Edit",
                component: "HiloButton",
                componentProps: (row) => ({
                  styleType: "editIcon",
                  onClick: () => this.navigateToEditInstructor(row.id),
                }),
              },
              {
                key: "profile",
                label: "Profile",
                component: "HiloButton",
                componentProps: (row) => ({
                  styleType: "profileIcon",
                  onClick: () => this.navigateToInstructorProfile(row.id),
                }),
              },
            ]
          : []),
        {
          key: "image",
          label: "Image",
          component: "img",
          componentProps: (row) => ({
            src: row.image || "/static/img/faces/face-0.jpg",
            alt: `${row.firstName} ${row.lastName}`,
            style: {
              width: "5em",
              height: "5em",
              borderRadius: "50%",
            },
          }),
        },
        { key: "firstName", label: "First" },
        { key: "lastName", label: "Last" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Phone" },
        { key: "role", label: "Role" },
      ],
    };
  },
  async mounted() {
    await this.getInstructors();
  },
  methods: {
    useLoginStore,
    async getInstructors() {
      return activeInstructorsAPIService
        .get(this.$router)
        .then((response) => {
          const apiUrl = process.env.VUE_APP_API_URL;
          this.instructors = response;
          for (let instructor of this.instructors) {
            instructor.firstName = instructor.user.firstName;
            instructor.lastName = instructor.user.lastName;
            instructor.email = instructor.user.email;
            instructor.phone = instructor.user.phone;
            instructor.role = instructor.instructorRole?.name;
            if (
              instructor.user.image &&
              typeof instructor.user.image === "string"
            ) {
              instructor.image = `${apiUrl}/file_uploads/${instructor.user.image.split("/").pop()}`;
            }
          }

          this.filteredInstructors = this.instructors;
        })
        .catch((error) => {
          this.error_txt = "Failed to get instructors: " + error;
          this.handleError();
        });
    },
    filterInstructors() {
      const searchTerm = this.search.toLowerCase();
      const columnKeys = this.columns.map((column) => column.key);
      this.filteredInstructors = this.instructors.filter((instructor) => {
        return columnKeys.some((key) => {
          const value = instructor[key];
          return value && value.toString().toLowerCase().includes(searchTerm);
        });
      });
    },
    navigateToAddInstructor() {
      this.$router.push({ name: "Add Edit Active Instructor" });
    },
    navigateToEditInstructor(id) {
      this.$router.push({ name: "Add Edit Active Instructor", params: { id } });
    },
    navigateToInstructorProfile(id) {
      this.$router.push({ name: "Profile Instructor", params: { id } });
    },
  },
};
</script>
<style scoped></style>
